(() => {
  const cfg = window.PITB_CUSTOMER || {};
  let navigating = false;

  const isLoginRequired = () => Boolean(cfg.loginRequired);
  const isLoggedIn = () => Boolean(cfg.loggedIn);
  const isNavigating = () => navigating;

  const checkoutButtons = () =>
    Array.from(
      document.querySelectorAll(
        '#checkout, #CartDrawer-Checkout, [data-pitb-checkout-gate], button[name="checkout"].cart__checkout-button, button[name="checkout"]'
      )
    );

  const lockCheckoutButtons = () => {
    checkoutButtons().forEach((btn) => {
      btn.classList.add('loading');
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('aria-disabled', 'true');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
    });
  };

  const beginNavigate = () => {
    if (navigating) {
      lockCheckoutButtons();
      return true;
    }
    navigating = true;
    lockCheckoutButtons();
    return true;
  };

  const cancelNavigate = () => {
    navigating = false;
    if (window.PITBEntryFee && typeof window.PITBEntryFee.setCheckoutLoading === 'function') {
      // Recompute busy from depth after clearing the navigate lock.
      window.PITBEntryFee.setCheckoutLoading(true);
      window.PITBEntryFee.setCheckoutLoading(false);
      return;
    }
    checkoutButtons().forEach((btn) => {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
    if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
      window.PITBBooking.syncCheckoutGate();
    }
  };

  const loginUrl = (returnPath) => {
    const base = cfg.loginUrl || '/account/login';
    const returnTo = returnPath || cfg.returnUrl || '/cart';
    try {
      const url = new URL(base, window.location.origin);
      if (!url.pathname.includes('/authentication')) {
        url.searchParams.set('return_url', returnTo);
      }
      return url.toString();
    } catch (_error) {
      return base;
    }
  };

  const redirectToLogin = (returnPath) => {
    beginNavigate();
    window.location.assign(loginUrl(returnPath));
  };

  const canProceedToCheckout = () => !isLoginRequired() || isLoggedIn();

  const proceedToCheckout = async (checkoutPath = '/checkout') => {
    beginNavigate();
    if (window.PITBQuantityLimit && !(await window.PITBQuantityLimit.validateCheckout())) {
      cancelNavigate();
      return false;
    }

    if (window.PITBEarlyAccess && typeof window.PITBEarlyAccess.ensureUnlocked === 'function') {
      const ok = await window.PITBEarlyAccess.ensureUnlocked(checkoutPath);
      if (!ok || (typeof window.PITBEarlyAccess.isUnlocked === 'function' && !window.PITBEarlyAccess.isUnlocked())) {
        navigating = false;
        if (window.PITBBooking && typeof window.PITBBooking.syncCheckoutGate === 'function') {
          window.PITBBooking.syncCheckoutGate();
        }
        return false;
      }
      lockCheckoutButtons();
    }
    if (!canProceedToCheckout()) {
      navigating = false;
      redirectToLogin(cfg.returnUrl || '/cart');
      return false;
    }
    window.location.assign(checkoutPath);
    return true;
  };

  window.PITBCheckoutAuth = {
    isLoginRequired,
    isLoggedIn,
    loginUrl,
    redirectToLogin,
    canProceedToCheckout,
    proceedToCheckout,
    isNavigating,
    beginNavigate,
    cancelNavigate,
    lockCheckoutButtons,
  };
})();
